import React, { Component } from "react";
import {
  mode,
  profile,
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DateRangePicker,
  Select,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  XLSX,
  saveAs,
  StatusTnx,
  linkRole,
} from "../../components/CustomComponent.js";

import { NumericFormat } from "react-number-format";

import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // MODAL
      modal_create: false,
      modal_update: false,
      modal_detail: false,
      modal_wallet_verify: false,
      modal_email_send: false,

      // SEARCH
      filter_status: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_data_search: params("ref_no") || "",
      filter_currency: "THB",
      filter_broker: "",

      // EXPORT
      export_date: "",

      // LIST
      loaded: false,
      data: [],
      count: 10,
      data_broker: [],
      data_customer: [],
      data_bank: [],
      data_user: [],

      // DETAIL
      customer_id: "",
      broker_id: "",

      uid: "",
      type: "",
      ref_no: "",
      status: "",
      amount: "",
      created_at: null,
      cost_gateway: "",
      fee: "",
      fee_rate: "",
      fee_type: "",
      vat: "",
      vat_rate: "",
      vat_type: "",
      is_vat: false,
      is_usdt: false,
      is_topup: false,
      is_hq: false,
      gateway: null,
      amount_net: "",
      open_balance: null,
      close_balance: null,
      currency: "",
      transaction_id: null,
      transfer_date: null,
      remark: null,
      broker: null,
      customer: null,

      bank_code: "",
      bank_account_number: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      wallet_verify_txn_uid: "",
      wallet_verify_address: "",
      wallet_verify_input: "",
      email_send_txn_uid: "",
      email_send_input: "",

      select: -1,
      hover_info_index: "",
      inline_help_popup: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get(1)]);
  }
  showInlineHelpPopup = (event, popup) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 260;
    const left = Math.min(
      Math.max(rect.left - 8, 16),
      window.innerWidth - popupWidth - 16,
    );
    const top = Math.max(rect.top - 16, 16);

    this.setState({
      inline_help_popup: {
        ...popup,
        left,
        top,
      },
    });
  };
  hideInlineHelpPopup = () => {
    this.setState({ inline_help_popup: null });
  };
  // ตัวเลือกของ dropdown ทั้งหน้า ไม่เปลี่ยนระหว่างอยู่บนหน้านี้ ดึงครั้งเดียวตอนเปิดหน้า
  // ไม่ยุ่งกับ loading เพราะ Get เป็นคนคุมสถานะโหลดของตาราง
  GetMaster = async () => {
    let data_broker, data_bank, data_user;
    let [result_broker, result_bank, result_user] = await Promise.all([
      GET("v1/admin/brokers/options", {
        page_size: 100000,
        page: 0,
        data_search: "",
      }),
      GET("v1/admin/banks", { page_size: 100000, page: 0, data_search: "" }),
      GET("v1/admin/users", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    if (result_broker?.status) {
      data_broker = result_broker.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        name_th: e.name_th,
        name_en: e.name_en,
      }));
    }
    if (result_bank?.status) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      data_bank = result_bank.data
        .sort((a, b) => {
          const indexA = popularBankCodes.indexOf(a.code);
          const indexB = popularBankCodes.indexOf(b.code);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
          } else if (indexA !== -1) {
            return -1; // a อยู่ใน popular → ให้มาก่อน
          } else if (indexB !== -1) {
            return 1; // b อยู่ใน popular → ให้มาก่อน
          } else {
            return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
          }
        })
        .map((e) => ({
          value: e.code,
          label: e.name_en,
          front: (
            <img
              alt="bank"
              src={require(
                `../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`,
              )}
              width={18}
              height={18}
              style={{ marginRight: 6 }}
            />
          ),
        }));
    }
    if (result_user?.status) {
      data_user = result_user.data
        .filter((e) => e.broker)
        .map((e) => ({
          value: e.email,
          label: `[${e.broker.name_en}] ${e.email} ${e.is_2fa ? "(2FA)" : ""}`,
          broker_id: e.broker.uid,
          is_2fa: e.is_2fa,
        }));
    }
    this.setState({ data_broker, data_bank, data_user });
  };
  Get = async (page) => {
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_currency,
      filter_broker,
    } = this.state;
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET(`transactions/withdrawals/list`, {
        page_size: 10,
        page: page,
        data_search: filter_data_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        filter_status: filter_status,
        process_type: "withdrawals",
        currency: filter_currency,
        broker_id: filter_broker,
        is_hq: true,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      loaded: true,
      data,
      count,
      select: -1,
    });
    loading(false);
  };

  GetCustomer = async (data_search = "") => {
    const { currency, broker_id } = this.state;
    let data_customer;
    let [result_customer] = await Promise.all([
      GET("v1/admin/customers", {
        page_size: 100000,
        page: 0,
        data_search: data_search,
        currency: currency,
        broker_id: broker_id,
      }),
    ]);
    if (result_customer?.status) {
      data_customer = result_customer?.data.map((e) => ({
        value: e.uid,
        label: e.name_en,
        bank_code: e.bank_code,
        bank_account_name_th: e.bank_account_name_th,
        bank_account_name_en: e.bank_account_name_en,
        bank_account_number: e.bank_account_number,
        broker: e.broker?.uid || "",
        currency: e.currency || "THB",
      }));
    }
    this.setState({
      data_customer,
    });
  };
  Create = async () => {
    const {
      broker_id,
      customer_id,
      ref_no,
      amount,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      currency,
      is_topup,
      is_hq,
    } = this.state;

    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please select Broker");
      return;
    } else if (!ref_no.trim()) {
      alert("", "warning", "Warning", "Please input Ref No");
      return;
    } else if (!amount.trim()) {
      alert("", "warning", "Warning", "Please input Amount");
      return;
    }

    let body = {
      broker_id,
      customer_id,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      ref_no,
      amount: Number(amount),
      currency: currency || "THB",
      is_topup: is_topup || false,
      is_hq: is_hq || false,
    };
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await POST(`transactions/withdrawals/create`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Update = async (is_approved_auto) => {
    const { fee_type, fee_rate, is_vat, status, is_usdt } = this.state;
    // fee_type / fee_rate are nullable in the DB (and fee_rate may arrive as a
    // number); calling .trim() on them directly threw inside the setState
    // callback and made Approve / Reject from the row menu fail silently
    if (!String(fee_type ?? "").trim()) {
      alert("", "warning", "Warning", "Please select Fee Rate Type");
      return;
    } else if (!String(fee_rate ?? "").trim()) {
      alert("", "warning", "Warning", "Please input Fee Rate");
      return;
    }
    if (["cancel", "success"].includes(status)) {
      Swal.fire({
        title: "Confirm",
        text: `Do you want to ${
          status === "cancel" ? "Reject" : "Approve"
        } the transaction?`,
        icon: "info",
        input: "textarea",
        inputPlaceholder: "Enter remark...",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
        color: mode === "dark" ? "#fff" : "#000000", // Text color
        confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
        cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
      }).then(async (re) => {
        if (re.isConfirmed) {
          const remark = re.value;
          loading(true);
          let body = {
            fee_type,
            fee_rate: Number(fee_rate).toFixed(4),
            is_vat,
            status,
            is_usdt,
            remark,
            is_approved_auto: is_approved_auto || false,
          };
          let result = await PUT(
            `transactions/withdrawals/update/` + this.state.uid,
            body,
          );
          if (result?.status) {
            // alert("#", "success");
            alert(
              "",
              "success",
              "Success",
              "Transaction updated successfully.",
            );
            this.Get(1);
            this.setState({
              modal_create: false,
              modal_update: false,
              modal_detail: false,
            });
          } else {
            alert(
              "",
              "warning",
              "Warning",
              result?.message || "An error occurred. Please try again.",
            );
          }
          loading(false);
        }
      });
    } else {
      if (
        await alert(
          "",
          "info",
          "Confirm",
          "Do you want to confirm the submission?",
          "Confirm",
          "Cancel",
        )
      ) {
        loading(true);
        let body = {
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          status,
          is_usdt,
          is_approved_auto: is_approved_auto || false,
        };
        let result = await PUT(
          `transactions/withdrawals/update/` + this.state.uid,
          body,
        );
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again.",
          );
        }
        loading(false);
      }
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      let result = await DELETE(`transactions/withdrawals/delete/` + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  ReWithdrawal = async () => {
    const { uid } = this.state;
    Swal.fire({
      title: "Confirm",
      text: `Do you want to "withdrawal" again?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      background: mode === "dark" ? "#000000" : "#fff", // Dark / Light background
      color: mode === "dark" ? "#fff" : "#000000", // Text color
      confirmButtonColor: mode === "dark" ? "#e29f04" : "#212529",
      cancelButtonColor: mode === "dark" ? "#aaa" : "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        loading(true);
        let body = { uid };
        let result = await POST(`transactions/withdrawals/re-order`, body);
        if (result?.status) {
          alert("#", "success");
        } else {
          alert(
            "",
            "warning",
            "Warning",
            result?.message || "An error occurred. Please try again.",
          );
        }
        loading(false);
      }
    });
  };
  calDetail = async () => {
    const { fee_type, fee_rate, is_vat, amount, cost_gateway } = this.state;
    const _amount = Number(amount);
    const _fee =
      fee_type === "fixed"
        ? Number(fee_rate)
        : Number((_amount * (Number(fee_rate) / 100)).toFixed(4));
    const _vat = Number((_fee * 0.07).toFixed(4));
    const amountAfterFee = _amount + _fee;
    let amountNet = is_vat
      ? Number((amountAfterFee + _vat + Number(cost_gateway)).toFixed(4))
      : Number(amountAfterFee.toFixed(4));

    this.setState({
      fee: _fee.toFixed(4),
      amount_net: amountNet.toFixed(4),
      vat: is_vat ? _vat.toFixed(4) : "00.00",
    });
  };
  Inquiry = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Inquiry?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await GET(`transactions/inquiry`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  Callback = async () => {
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the Callback?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const { uid } = this.state;
      let body = { uid };
      let result = await POST(`callback/re-callback`, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  OpenWalletVerifyModal = (item) => {
    this.setState({
      ...item,
      modal_wallet_verify: true,
      wallet_verify_txn_uid: item?.uid || "",
      wallet_verify_address: item?.settlement?.wallet_address || "",
      wallet_verify_input: "",
    });
  };
  OpenEmailSendModal = (item) => {
    this.setState({
      ...item,
      broker_id: item?.broker?.uid || "",
      customer_id: item?.customer?.uid || "",
      modal_email_send: true,
      email_send_txn_uid: item?.uid || "",
      email_send_input: item?.settlement?.email || item?.broker?.email || "",
    });
  };
  ConfirmWalletVerify = async () => {
    const {
      wallet_verify_txn_uid,
      wallet_verify_address,
      wallet_verify_input,
      fee_type,
      fee_rate,
      is_vat,
      is_usdt,
    } = this.state;
    const walletAddress = wallet_verify_address.trim();
    const walletInput = wallet_verify_input.trim();

    if (!walletAddress) {
      alert("", "warning", "Warning", "Wallet address not found.");
      return;
    }

    if (walletInput !== walletAddress) {
      alert("", "warning", "Warning", "Wallet address does not match.");
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm this wallet address?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const result = await PUT(
        `transactions/withdrawals/verify-wallet/${wallet_verify_txn_uid}`,
        {
          wallet_address: walletInput,
        },
      );

      if (result?.status) {
        let body = {
          status: "success",
          fee_type,
          fee_rate: Number(fee_rate).toFixed(4),
          is_vat,
          is_usdt,
          is_approved_auto: false,
        };
        await PUT(`transactions/withdrawals/update/` + this.state.uid, body);
        alert(
          "",
          "success",
          "Success",
          "Wallet address verified successfully.",
        );
        this.setState({
          modal_wallet_verify: false,
          wallet_verify_txn_uid: "",
          wallet_verify_address: "",
          wallet_verify_input: "",
        });
        await this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  ConfirmSendEmail = async () => {
    const { email_send_txn_uid, email_send_input } = this.state;
    const email = email_send_input.trim();

    if (!email) {
      alert("", "warning", "Warning", "Please input email.");
      return;
    }

    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to send this settlement email?",
        "Confirm",
        "Cancel",
      )
    ) {
      loading(true);
      const result = await PUT(
        `transactions/withdrawals/send-settlement-email/${email_send_txn_uid}`,
        {
          email,
        },
      );

      if (result?.status) {
        alert("", "success", "Success", "Settlement email sent successfully.");
        this.setState({
          modal_email_send: false,
          email_send_txn_uid: "",
          email_send_input: "",
        });
        await this.Get(1);
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again.",
        );
      }
      loading(false);
    }
  };
  ExportCSV = async () => {
    const {
      filter_data_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      filter_currency,
      filter_broker,
    } = this.state;
    loading(true);
    let result = await GET(`transactions/withdrawals/list`, {
      page_size: 100000,
      page: 0,
      data_search: filter_data_search,
      start_date: filter_start_date
        ? format_date(filter_start_date, "yyyy-mm-dd", "en")
        : "",
      end_date: filter_end_date
        ? format_date(filter_end_date, "yyyy-mm-dd", "en")
        : "",
      filter_status: filter_status,
      process_type: "withdrawals",
      currency: filter_currency,
      broker_id: filter_broker,
      is_hq: true,
    });
    if (result?.status) {
      const data_transaction = result.data;

      // EXPORT CSV
      const json_data = data_transaction.map((item) => ({
        time: format_date(item.created_at, "dd/mm/yy hh:mm", "en"),
        "Ref No": item.ref_no,
        Broker: item.broker?.name_en || "-",
        Amount: toFixed(item.amount, 2),
        Fee: toFixed(item.fee, 2),
        VAT: toFixed(item.vat, 2),
        "Amount Net": toFixed(item.amount_net, 2),
        Process: "HQ",
        Status: item.status || "-",
        Remark: item.remark,
        currency: item.currency,
      }));
      // 1. Convert JSON to worksheet
      const worksheet_thb = XLSX.utils.json_to_sheet(
        json_data.filter((e) => e.currency === "THB"),
      );
      const worksheet_lak = XLSX.utils.json_to_sheet(
        json_data.filter((e) => e.currency === "LAK"),
      );

      // 2. Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet_thb, "THB");
      XLSX.utils.book_append_sheet(workbook, worksheet_lak, "LAK");

      // 3. Write the workbook to binary buffer
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // 4. Save to file
      const data = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(
        data,
        `settlementHQ-${format_date(
          filter_start_date,
          "dd/mm/yy",
          "en",
        )}-${format_date(filter_end_date, "dd/mm/yy", "en")}.xlsx`,
      );
    }
    loading(false);
  };

  // ไอคอนติ๊กถูก/กากบาทที่ใช้ซ้ำในคอลัมน์ verify ทั้ง 3 ตัว
  renderCheck = (ok, title) => (
    <span className={`pu-shq-check ${ok ? "on" : "off"}`} title={title}>
      <span className="icon">{ok ? "" : ""}</span>
    </span>
  );

  render() {
    const {
      select,
      modal_create,
      modal_update,
      modal_detail,
      modal_wallet_verify,
      modal_email_send,
      filter_status,
      filter_start_date,
      filter_end_date,
      filter_data_search,
      filter_currency,
      filter_broker,
      loaded,
      data,
      count,
      data_broker,
      data_customer,
      data_user,
      data_bank,
      broker_id,
      customer_id,
      uid,
      type,
      ref_no,
      status,
      amount,
      created_at,
      fee,
      fee_rate,
      fee_type,
      vat,
      is_vat,
      amount_net,
      currency,
      remark,
      broker,
      customer,
      cost_gateway,
      bank_code,
      bank_account_number,
      bank_account_name_th,
      bank_account_name_en,
      is_usdt,
      wallet_verify_address,
      email_send_input,
      hover_info_index,
      inline_help_popup,
    } = this.state;
    const hasFocusedOverlay = !!hover_info_index;
    const rows = Array.isArray(data) ? data : [];
    const selectedBrokerLabel = data_broker?.find((b) => b.value === filter_broker)?.label;
    const bankIcon = (code) => global.bank?.find((b) => b.value === code)?.icon || "bank.png";
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className={`market-monitor-overlay ${hasFocusedOverlay ? "show" : ""}`}></div>
          {inline_help_popup && (
            <div
              className="inline-help-popup"
              style={{
                left: inline_help_popup.left,
                top: inline_help_popup.top,
              }}
            >
              <div className="fw-semibold mb-1" style={{ color: inline_help_popup.titleColor || "#344054" }}>
                {inline_help_popup.title}
              </div>
              {inline_help_popup.lines?.map((line, popupIndex) => (
                <div
                  key={`inline-help-${popupIndex}`}
                  style={{
                    color: "#475467",
                    fontSize: 12,
                    lineHeight: 1.5,
                    wordBreak: "break-word",
                  }}
                >
                  {line}
                </div>
              ))}
            </div>
          )}

          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Settlement</div>
                <div className="ar-title">Settlement HQ Management</div>
                <div className="ar-subtitle">Manage and monitor Settlement HQ transactions, wallet verification and approvals.</div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-ghost"
                  onClick={async () => {
                    this.ExportCSV();
                  }}
                >
                  <span className="icon me-2">{""}</span>Export CSV
                </button>
                <button
                  className="ar-btn-gold settlements-hq.create"
                  onClick={async () => {
                    this.setState({
                      id: "",
                      currency: "THB",
                      broker_id: profile?.user_type === "broker" ? profile?.broker?.uid : "",
                      customer_id: "",
                      ref_no: "",
                      amount: "",
                      is_topup: false,
                      is_hq: true,
                      modal_create: true,
                    });
                  }}
                >
                  <span className="icon me-2">{""}</span>Create Settlement HQ
                </button>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search ref no..."
                onChange={(e) => {
                  this.setState({ filter_data_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_data_search}
              />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Broker</span>
                <Select
                  className="form-control"
                  placeholder="All brokers"
                  options={data_broker}
                  onChange={(e) => {
                    this.setState({
                      filter_broker: e,
                    });
                  }}
                  value={filter_broker}
                />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Status</span>
              <Select
                className="form-control"
                placeholder="Status"
                options={[
                  { value: "", label: "All status" },
                  { value: "pending", label: "Pending" },
                  { value: "success", label: "Success" },
                  { value: "mismatch", label: "MisMatch" },
                  { value: "pending-refund", label: "Pending Refund" },
                  { value: "refund", label: "Refund" },
                  { value: "cancel", label: "Cancel" },
                ]}
                value={filter_status}
                onChange={(v) => {
                  this.setState({ filter_status: v });
                }}
                default={false}
              />
                </div>
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Date Range</span>
                <DateRangePicker
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      filter_start_date: e.start_date,
                      filter_end_date: e.end_date,
                    });
                  }}
                  value={{
                    start_date: filter_start_date,
                    end_date: filter_end_date,
                  }}
                  max={filter_end_date}
                />
                </div>
              <div className="ar-toolbar-actions">
                <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                  <span className="icon me-2">{""}</span>Search
                </button>
                <button
                  className="ar-btn-ghost"
                  onClick={() =>
                    this.setState(
                      {
                        filter_data_search: params("ref_no") || "",
                        filter_start_date: "",
                        filter_end_date: "",
                        filter_status: "",
                        filter_currency: "THB",
                        filter_broker: "",
                      },
                      () => this.Get(1)
                    )
                  }
                >
                  Reset
                </button>
              </div>
              </div>
              <div className="ar-filter-foot">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {global.currency?.map((item) => (
                  <button
                    key={item.currency_code}
                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    {item.image}
                    {item.currency_code}
                  </button>
                ))}
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Settlement HQ
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">
                  {count || 0} transaction{count === 1 ? "" : "s"} · {selectedBrokerLabel || "All brokers"} · showing {rows.length} on this page
                </div>
              </div>
              <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <span className="pu-legend-dot on" />
                  Verified
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Not verified
                </span>
                <span>
                  <span className="pu-legend-swatch" />
                  Selected row (double-click)
                </span>
              </div>
            </div>
            <div className="table-responsive" style={{ minHeight: 400 }}>
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap">Time</td>
                    <td className="text-nowrap">Ref No</td>
                    <td className="text-nowrap">Broker</td>
                    <td className="text-nowrap text-end">Amount</td>
                    <td className="text-nowrap">Send Email</td>
                    <td className="text-nowrap">Wallet Address</td>
                    <td className="text-nowrap text-center">Wallet</td>
                    <td className="text-nowrap text-center">Password</td>
                    <td className="text-nowrap text-center">2FA</td>
                    <td className="text-nowrap text-center">Expire</td>
                    <td className="text-nowrap text-center d-none d-md-table-cell">Process</td>
                    <td className="text-nowrap text-center wpx-100">Status</td>
                    <td className="settlements-hq.update text-nowrap text-center td-actions">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={13} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No Settlement HQ transactions found</div>
                          <div className="text-secondary text-14">Try another search, status, date range or currency.</div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.map((item, index) => {
                    const brokerName = item.broker?.name_en || item.broker?.name_th || "-";
                    const email = item.settlement?.email || item.broker?.email || "";
                    const walletAddress = item.settlement?.wallet_address || "";
                    const walletVerified = !!item.settlement?.is_wallet_address_verify;
                    const closed = ["success", "cancel"].includes(item.status);
                    const emailDisabled = walletVerified;
                    const walletDisabled = walletVerified || closed;
                    return (
                      <tr
                        key={item.uid || `array-${index}`}
                        className={index === select ? "pu-row-selected" : ""}
                        onDoubleClick={() => {
                          this.setState({
                            select: select === index ? -1 : index,
                          });
                        }}
                      >
                        <td data-label="Time" className="text-nowrap">
                          <div className="pu-shq-time">{format_date(item.created_at, "dd/mm/yy", "en")}</div>
                          <div className="pu-sub pu-mono">{format_date(item.created_at, "hh:mm:ss", "en")}</div>
                        </td>
                        <td data-label="Ref No" className="text-nowrap">
                          <div className="pu-uid">
                            <span className="pu-shq-ref">{item.ref_no || "-"}</span>
                            {item.ref_no_refund && (
                              <div className="pu-sub">
                                refund: <span className="pu-mono">{item.ref_no_refund}</span>
                                <span
                                  className="icon ms-1 pu-link pointer"
                                  title="Open refund transaction"
                                  onClick={() => {
                                    window.location.href = `/${linkRole(profile?.user_type)}/deposits-withdrawals?type=withdrawals&ref_no=${item.ref_no_refund}`;
                                  }}
                                >
                                  {""}
                                </span>
                              </div>
                            )}
                          </div>
                        </td>
                        <td data-label="Broker" className="text-nowrap">
                          <div className="pu-user">
                            <div className="min-w-0">
                              <div className="pu-name text-truncate" title={brokerName}>
                                {brokerName}
                              </div>
                              {item.broker?.name_en && item.broker?.name_th && (
                                <div className="pu-sub">
                                  <span className="text-truncate">{item.broker.name_th}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td data-label="Amount" className="text-nowrap text-end">
                          <div className="pu-amount pu-amount-gold">{toFixed(item.amount, 2)}</div>
                          <div className="pu-sub justify-content-end">{item.currency || filter_currency}</div>
                        </td>
                        <td data-label="Send Email" className="text-nowrap">
                          <div className="pu-shq-cell">
                            <span className={`pu-shq-text ${email ? "" : "pu-none"}`} title={email}>
                              {email || "-"}
                            </span>
                            {!!email && (
                              <button
                                type="button"
                                className={`ar-row-action pu-shq-act ${emailDisabled ? "" : "warn"}`}
                                disabled={emailDisabled}
                                title={emailDisabled ? "Wallet already verified" : "Send settlement email"}
                                onMouseEnter={(event) => {
                                  this.setState({
                                    hover_info_index: `email-${index}`,
                                  });
                                  this.showInlineHelpPopup(event, {
                                    title: "Settlement Email",
                                    titleColor: "#b54708",
                                    lines: ["Click to send the settlement email."],
                                  });
                                }}
                                onMouseLeave={() => {
                                  this.setState({ hover_info_index: "" });
                                  this.hideInlineHelpPopup();
                                }}
                                onClick={() => {
                                  if (!emailDisabled) {
                                    this.OpenEmailSendModal(item);
                                  }
                                }}
                              >
                                <span className="icon">{""}</span>
                              </button>
                            )}
                          </div>
                        </td>
                        <td data-label="Wallet Address" className="text-nowrap">
                          <div className="pu-shq-cell">
                            <span className={`pu-shq-text pu-mono ${walletAddress ? "" : "pu-none"}`} title={walletAddress}>
                              {walletAddress ? (walletAddress.length > 20 ? `${walletAddress.slice(0, 20)}...` : walletAddress) : "-"}
                            </span>
                            {!!walletAddress && (
                              <button
                                type="button"
                                className={`ar-row-action pu-shq-act ${walletDisabled ? "" : "info"}`}
                                title={walletDisabled ? "Wallet verification closed" : "Verify this wallet address"}
                                onMouseEnter={(event) => {
                                  this.setState({
                                    hover_info_index: `wallet-${index}`,
                                  });
                                  this.showInlineHelpPopup(event, {
                                    title: "Wallet Verification",
                                    titleColor: "#344054",
                                    lines: ["Click to verify this wallet address."],
                                  });
                                }}
                                onMouseLeave={() => {
                                  this.setState({ hover_info_index: "" });
                                  this.hideInlineHelpPopup();
                                }}
                                onClick={() => {
                                  this.OpenWalletVerifyModal(item);
                                }}
                              >
                                <span className="icon">{""}</span>
                              </button>
                            )}
                          </div>
                        </td>
                        <td data-label="Wallet" className="text-nowrap text-center">
                          {this.renderCheck(walletVerified, walletVerified ? "Wallet verified" : "Wallet not verified")}
                        </td>
                        <td data-label="Password" className="text-nowrap text-center">
                          {this.renderCheck(!!item.settlement?.is_password_verify, item.settlement?.is_password_verify ? "Password verified" : "Password not verified")}
                        </td>
                        <td data-label="2FA" className="text-nowrap text-center">
                          {this.renderCheck(!!item.settlement?.is_2fa_verify, item.settlement?.is_2fa_verify ? "2FA verified" : "2FA not verified")}
                        </td>
                        <td data-label="Expire" className="text-nowrap text-center">
                          {item.settlement?.expire_at ? (
                            <>
                              <div className="pu-shq-time">{format_date(item.settlement.expire_at, "dd/mm/yy", "en")}</div>
                              <div className="pu-sub pu-mono justify-content-center">{format_date(item.settlement.expire_at, "hh:mm", "en")}</div>
                            </>
                          ) : (
                            <span className="pu-none">-</span>
                          )}
                        </td>
                        <td data-label="Process" className="text-nowrap text-center d-none d-md-table-cell">
                          <div className="d-flex align-items-center justify-content-center">
                            {!item.is_topup && !item.is_hq && (item.process_type === "manual" ? Status("manual", "info") : item.process_type === "auto" ? Status("auto", "success") : Status("-", "warning"))}
                            {item.is_topup && Status("topup", "primary")}
                            {item.is_hq && Status("HQ", "purple")}
                          </div>
                        </td>
                        <td data-label="Status" className="text-nowrap text-center">
                          <div className="d-flex align-items-center justify-content-center">{StatusTnx(item.status)}</div>
                        </td>
                        <td data-label="Actions" className="settlements-hq.update text-center td-actions">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`settlement-hq-actions-${index}`}>Action</Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item
                                className="pu-action-item"
                                onClick={() => {
                                  this.setState({ ...item, modal_detail: true });
                                }}
                              >
                                <span className="icon">{""}</span>Detail
                              </Dropdown.Item>
                              {(item.status === "pending" || (profile.user_type === "super_user" && item.status === "cancel")) && (
                                <>
                                  <div className="pu-action-sep" />
                                  <Dropdown.Item
                                    className="pu-action-item settlements-hq.update"
                                    onClick={() => {
                                      this.setState(
                                        {
                                          ...item,
                                          status: "success",
                                        },
                                        () => {
                                          this.Update();
                                        }
                                      );
                                    }}
                                  >
                                    <span className="icon">{""}</span>Approve
                                  </Dropdown.Item>
                                </>
                              )}
                              {(item.status === "pending" || (profile.user_type === "super_user" && item.status === "success")) && (
                                <Dropdown.Item
                                  className="pu-action-item danger settlements-hq.update"
                                  onClick={() => {
                                    this.setState({ ...item, status: "cancel" }, () => {
                                      this.Update();
                                    });
                                  }}
                                >
                                  <span className="icon">{""}</span>Reject
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-3">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>

        {/* CREATE */}
        <Modal show={modal_create} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_create: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">New settlement</div>
              <h5 className="fw-bold mb-0">Create Settlement HQ</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Transaction
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Currency{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select currency"
                    options={global.currency?.map((e) => ({
                      label: e.currency_code,
                      value: e.currency_code,
                      front: e.image,
                    }))}
                    onChange={(e, i) => {
                      this.setState(
                        {
                          currency: e,
                          broker_id: e ? broker_id : "",
                          customer_id: e ? customer_id : "",
                          bank_code: e ? bank_code : "",
                          bank_account_number: e ? bank_account_number : "",
                          bank_account_name_th: e ? bank_account_name_th : "",
                          bank_account_name_en: e ? bank_account_name_en : "",
                        },
                        () => {
                          this.GetCustomer();
                        }
                      );
                    }}
                    value={currency}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Broker{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select broker"
                    options={data_broker}
                    onChange={(e, i) => {
                      this.setState(
                        {
                          broker_id: e,
                          customer_id: "",
                          bank_code: "SCB",
                          bank_account_name_th: e ? i.name_th : "-",
                          bank_account_name_en: e ? i.name_en : "-",
                          bank_account_number: "1",
                        },
                        () => {
                          this.GetCustomer();
                        }
                      );
                    }}
                    value={broker_id}
                    disabled={!currency}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Customer</label>
                  <Select
                    className="form-control"
                    placeholder="Select customer (optional)"
                    options={data_customer?.filter((e) => e.broker === broker_id).filter((e) => e.currency === currency)}
                    onChange={(e, i) => {
                      this.setState({
                        customer_id: e,
                        bank_code: e ? i.bank_code : "",
                        bank_account_name_th: e ? i.bank_account_name_th : "",
                        bank_account_name_en: e ? i.bank_account_name_en : "",
                        bank_account_number: e ? i.bank_account_number : "",
                      });
                    }}
                    onKeyUp={(e) => {
                      this.GetCustomer(e);
                    }}
                    value={customer_id}
                    disabled={!broker_id}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Ref no{required}</label>
                  <div className="pu-password">
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Reference number"
                      maxLength={100}
                      onChange={(e) => {
                        this.setState({ ref_no: e.target.value });
                      }}
                      value={ref_no}
                    />
                    <button
                      type="button"
                      className="pu-generate"
                      title="Generate a reference number"
                      onClick={() => {
                        this.setState({ ref_no: new Date().getTime().toString() });
                      }}
                    >
                      <span className="icon me-2">{""}</span>Generate
                    </button>
                  </div>
                </div>
                <div className="col-12">
                  <label className="pr-label">Amount{required}</label>
                  <div className="position-relative">
                    <NumericFormat
                      thousandSeparator=","
                      decimalScale={2}
                      type="text"
                      className="form-control pr-input pe-5"
                      placeholder="0.00"
                      value={amount}
                      onValueChange={(e) => {
                        this.setState({ amount: e.value });
                      }}
                    />
                    <span className="pu-input-suffix">{currency || "THB"}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`pu-section ${!broker_id ? "pu-section-muted" : ""}`}>
              <div className="pu-section-title">
                <span className="icon">{""}</span>Bank Information
                {!broker_id && <span className="pu-section-note">Select a broker first</span>}
              </div>
              {broker_id ? (
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Bank Name{required}</label>
                    <Select
                      className="form-control"
                      placeholder="Select bank"
                      options={data_bank}
                      onChange={(e) => {
                        this.setState({ bank_code: e });
                      }}
                      value={bank_code}
                      disabled={customer_id}
                    ></Select>
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Number{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Account number"
                      maxLength={20}
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ bank_account_number: e.target.value });
                      }}
                      value={bank_account_number}
                      disabled={customer_id}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Name TH{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="ชื่อบัญชีภาษาไทย"
                      onChange={(e) => {
                        this.setState({ bank_account_name_th: e.target.value });
                      }}
                      value={bank_account_name_th}
                      disabled={customer_id}
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="pr-label">Account Name EN{required}</label>
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Account name in English"
                      onChange={(e) => {
                        this.setState({ bank_account_name_en: e.target.value });
                      }}
                      value={bank_account_name_en}
                      disabled={customer_id}
                    />
                  </div>
                  {customer_id && <div className="col-12 pu-hint mt-0">Bank details are taken from the selected customer.</div>}
                </div>
              ) : (
                <div className="pu-hint">Bank details are filled in automatically once a broker is selected.</div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.Create();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_create: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* UPDATE */}
        <Modal show={modal_update} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_update: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Edit settlement</div>
              <h5 className="fw-bold mb-0">Update Settlement HQ</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Transaction
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Status</span>
                <span className="pu-kv-value">{StatusTnx(status)}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Ref No.</span>
                <span className="pu-kv-value pu-mono">{ref_no}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Time</span>
                <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Type</span>
                <span className="pu-kv-value text-capitalize">{type}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Customer</span>
                <span className="pu-kv-value">{customer?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Broker</span>
                <span className="pu-kv-value">{broker?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Remark</span>
                <span className="pu-kv-value">{remark || <span className="pu-none">-</span>}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Accountant Remark</span>
                <span className="pu-kv-value">
                  <span className="pu-none">-</span>
                </span>
              </div>
            </div>

            <div className={`pu-section ${is_usdt ? "pu-section-muted" : ""}`}>
              <div className="pu-section-title">
                <span className="icon">{""}</span>Fee &amp; VAT
                {is_usdt && <span className="pu-section-note">Not applied for USDT</span>}
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Fee Rate Type</label>
                  <Select
                    className="form-control"
                    placeholder="Fee rate type"
                    options={[
                      { value: "percentage", label: "Percentage" },
                      { value: "fixed", label: "Fixed" },
                    ]}
                    onChange={(e) => {
                      this.setState({ fee_type: e });
                      setTimeout(() => {
                        this.calDetail();
                      }, 10);
                    }}
                    value={fee_type}
                    disabled={is_usdt}
                  ></Select>
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Fee Rate</label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pr-input pe-5"
                      placeholder="0.00"
                      onChange={(e) => {
                        if (!float(e.target.value, 4)) return;
                        this.setState({ fee_rate: e.target.value });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      value={!is_usdt ? fee_rate : "0.00"}
                      disabled={is_usdt}
                    />
                    <span className="pu-input-suffix">{fee_type === "percentage" ? "%" : currency || "THB"}</span>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="pu-toggle">
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_vat: e });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      checked={is_vat && !is_usdt}
                      disabled={is_usdt}
                    />
                    <div>
                      <div className="pu-toggle-title">{is_vat && !is_usdt ? "VAT" : "NO VAT"}</div>
                      <div className="pu-toggle-desc">Apply VAT on top of the fee</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="pu-toggle">
                    <Switch
                      onChange={(e) => {
                        this.setState({ is_usdt: e });
                        setTimeout(() => {
                          this.calDetail();
                        }, 10);
                      }}
                      checked={is_usdt}
                    />
                    <div>
                      <div className="pu-toggle-title">USDT</div>
                      <div className="pu-toggle-desc">Settle in USDT, fee and VAT are not applied</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pu-section pu-section-gold">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Summary
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Amount</span>
                <span className="pu-kv-value">
                  {toFixed(amount, 2)} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(fee, 2) : "0.00"} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">VAT</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(vat, 2) : "0.00"} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv total">
                <span className="pu-kv-label">Amount Net</span>
                <span className="pu-kv-value">
                  {!is_usdt ? toFixed(amount_net, 2) : toFixed(amount, 2)} {currency || "THB"}
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill settlements-hq.update"
              onClick={() => {
                this.Update();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({ modal_update: false });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* DETAIL */}
        <Modal show={modal_detail} dialogClassName="pr-modal pr-scope pu-scope" onHide={() => this.setState({ modal_detail: false })}>
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Settlement detail</div>
              <h5 className="fw-bold mb-0">
                Settlement HQ <span className="pu-mono text-secondary fw-normal text-14">{ref_no}</span>
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Transaction
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Status</span>
                <span className="pu-kv-value">{StatusTnx(status)}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Ref No.</span>
                <span className="pu-kv-value pu-mono">{ref_no}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Time</span>
                <span className="pu-kv-value">{format_date(created_at, "dd/mm/yyyy", "en")}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Type</span>
                <span className="pu-kv-value text-capitalize">{type}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Customer</span>
                <span className="pu-kv-value">{customer?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Broker</span>
                <span className="pu-kv-value">{broker?.name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Remark</span>
                <span className="pu-kv-value">{remark || <span className="pu-none">-</span>}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Accountant Remark</span>
                <span className="pu-kv-value">
                  <span className="pu-none">-</span>
                </span>
              </div>
              {profile?.user_type === "super_user" && (
                <div className="pu-kv">
                  <span className="pu-kv-label">Url Payment</span>
                  <span className="pu-kv-value text-truncate">
                    <a className="pu-link" href={`${window.location.origin}/qr-source-link?i=${uid}`} target="_blank" rel="noopener noreferrer">
                      {window.location.origin}/qr-source-link?i={uid}
                    </a>
                  </span>
                </div>
              )}
            </div>

            <div className="pu-section pu-section-gold">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Fee &amp; Amount
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee Rate Type</span>
                <span className="pu-kv-value text-capitalize">{fee_type || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee Rate</span>
                <span className="pu-kv-value">
                  {toFixed(fee_rate, 2)} {fee_type === "percentage" ? "%" : currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Amount</span>
                <span className="pu-kv-value">
                  {toFixed(amount, 2)} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee Gateway</span>
                <span className="pu-kv-value">
                  {toFixed(cost_gateway, 2)} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Fee</span>
                <span className="pu-kv-value">
                  {toFixed(fee, 2)} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">VAT Type</span>
                <span className="pu-kv-value">{is_vat ? "VAT" : "NO VAT"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">VAT</span>
                <span className="pu-kv-value">
                  {toFixed(vat, 2)} {currency || "THB"}
                </span>
              </div>
              <div className="pu-kv total">
                <span className="pu-kv-label">Amount Net</span>
                <span className="pu-kv-value">
                  {toFixed(amount_net, 2)} {currency || "THB"}
                </span>
              </div>
            </div>

            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Bank Information
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Bank Name</span>
                <span className="pu-kv-value">
                  <span className="pu-bank justify-content-end">
                    <img alt="bank" src={require(`../../assets/images/bank/${bankIcon(bank_code)}`)} />
                    <span className="pu-bank-code">{bank_code || "-"}</span>
                  </span>
                </span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Number</span>
                <span className="pu-kv-value pu-mono">{bank_account_number || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name EN</span>
                <span className="pu-kv-value">{bank_account_name_en || "-"}</span>
              </div>
              <div className="pu-kv">
                <span className="pu-kv-label">Account Name TH</span>
                <span className="pu-kv-value">{bank_account_name_th || "-"}</span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-outline-dark px-5 rounded-pill"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* WALLET VERIFY */}
        <Modal
          show={modal_wallet_verify}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() =>
            this.setState({
              modal_wallet_verify: false,
              wallet_verify_txn_uid: "",
              wallet_verify_address: "",
              wallet_verify_input: "",
            })
          }
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Wallet verification</div>
              <h5 className="fw-bold mb-0">Confirm Wallet Address</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Wallet Address
              </div>
              <div className="pu-password">
                <div className="form-control pr-input bg-light text-break pu-shq-readonly">{wallet_verify_address || "-"}</div>
                {!!wallet_verify_address && (
                  <button
                    type="button"
                    className="pu-copy-btn"
                    title="Copy wallet address"
                    onClick={async () => {
                      await navigator.clipboard.writeText(wallet_verify_address);
                      alert("", "success", "Success", "Copied wallet address.");
                    }}
                  >
                    <span className="icon me-2">{""}</span>Copy
                  </button>
                )}
              </div>
              <div className="pu-hint">Approve only after the broker has confirmed this address through their own channel.</div>
            </div>
            {/* {!this.state.settlement?.is_wallet_address_verify && (
                    <div className="mb-2">
                        <label className="form-label fw-bold">Input Wallet Address</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter wallet address to confirm"
                            value={wallet_verify_input}
                            onChange={(e) => {
                                this.setState({ wallet_verify_input: e.target.value });
                            }}
                        />
                    </div>
                    )}
                    {wallet_verify_input && wallet_verify_input.trim() !== wallet_verify_address.trim() && <div className="text-danger small">Wallet address does not match.</div>} */}
          </Modal.Body>
          {!["success", "cancel"].includes(this.state.status) && (
            <Modal.Footer className="pr-modal-footer">
              <button
                className="btn btn-outline-dark px-4 rounded-pill me-auto"
                onClick={() => {
                  this.setState({
                    modal_wallet_verify: false,
                    wallet_verify_txn_uid: "",
                    wallet_verify_address: "",
                    wallet_verify_input: "",
                  });
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-outline-danger px-4 rounded-pill settlements-hq.update"
                onClick={() => {
                  this.setState({ status: "cancel" }, () => {
                    this.Update();
                  });
                }}
              >
                <span className="icon me-2">{""}</span>Reject
              </button>
              <button
                className="btn btn-dark px-4 rounded-pill settlements-hq.update"
                onClick={() => {
                  this.setState({ wallet_verify_input: wallet_verify_address }, () => {
                    this.ConfirmWalletVerify();
                  });
                }}
              >
                <span className="icon me-2">{""}</span>Approve
              </button>
            </Modal.Footer>
          )}
        </Modal>

        {/* EMAIL SEND */}
        <Modal
          show={modal_email_send}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={() =>
            this.setState({
              modal_email_send: false,
              email_send_txn_uid: "",
              email_send_input: "",
            })
          }
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Settlement email</div>
              <h5 className="fw-bold mb-0">Confirm Send Settlement Email</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Recipient
              </div>
              <label className="pr-label">Email</label>
              <div className="pu-password">
                <Select
                  className="form-control"
                  placeholder="Select email"
                  options={[...data_user.filter((e) => e.broker_id === broker_id), { label: "[MANUAL] tech_support@zenithlink.tech", value: "tech_support@zenithlink.tech" }]}
                  onChange={(e) => {
                    this.setState({
                      email_send_input: e,
                    });
                  }}
                  value={email_send_input}
                />
                <button
                  type="button"
                  className="pu-copy-btn"
                  title="Copy email"
                  disabled={!email_send_input.trim()}
                  onClick={async () => {
                    await navigator.clipboard.writeText(email_send_input);
                    alert("", "success", "Success", "Copied email.");
                  }}
                >
                  <span className="icon me-2">{""}</span>Copy
                </button>
              </div>
              <div className="pu-hint pu-shq-hint-warn">
                <span className="icon me-2">{""}</span>Only users who have enabled 2FA (Two-Factor Authentication) will be able to send emails.
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill settlements-hq.update"
              disabled={!email_send_input.trim()}
              onClick={() => {
                if (data_user?.find((e) => e.value === email_send_input)?.is_2fa) {
                  this.ConfirmSendEmail();
                } else {
                  alert("", "warning", "Warning", "Only users who have enabled 2FA (Two-Factor Authentication) will be able to send emails.");
                }
              }}
            >
              <span className="icon me-2">{""}</span>Confirm
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={() => {
                this.setState({
                  modal_email_send: false,
                  email_send_txn_uid: "",
                  email_send_input: "",
                });
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
